import * as React from "react"
import {Card, Classes, Intent, Switch} from "@blueprintjs/core"
import {useTranslation} from "react-i18next"
import {useDispatch} from "react-redux"
import {useState} from "react"
import handleBooleanChange from "../../core/utils/handleChangehelpers"
import {saveTermsAction} from "../../core/actions/core.actions"
import Terms from "../../core/models/terms"
import ActionButton from "../../core/components/buttons/ActionButton"

type Props = {}

const DisplayDisclaimerPanel: React.FC<Props> = () => {
    const {t} = useTranslation()
    const dispatch = useDispatch()
    const [terms, setTerms] = useState<Terms>({
        licencesTerm: false,
        diagnosisTerm: false,
    })

    const handleContinue = (e: React.FormEvent) => {
        dispatch(saveTermsAction(terms))
    }

    const term1 = (e: any) => {
        setTerms({...terms, licencesTerm: e})
    }
    const term2 = (e: any) => {
        setTerms({...terms, diagnosisTerm: e})
    }

    return (
        <form>
            <div className={Classes.DIALOG_BODY}>
                <Card>
                    <div className="CardRow">
                        <Switch
                            className="CardRowElement"
                            labelElement="I understand and accept the terms and conditions for using this reference database as laid out in the license contract. Downloaded data is not to be published unless an active license is held and biocrates life sciences ag is clearly mentioned as the data source.
"
                            onChange={handleBooleanChange((value) =>
                                term1(value)
                            )}
                        />
                    </div>
                    <div className="CardRow">
                        <Switch
                            className="CardRowElement"
                            labelElement="I understand and accept the reference ranges do not represent a diagnosis but serve as a means of comparison only. A reference range provides no statement about whether a person is sick or healthy. Individuals with metabolite concentrations ​​outside the reference range can therefore be healthy and individuals with metabolite concentrations ​​in the reference range can be ill.
"
                            onChange={handleBooleanChange((value) =>
                                term2(value)
                            )}
                        />
                    </div>
                </Card>
            </div>
            <div className={Classes.DIALOG_FOOTER}>
                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                    <ActionButton
                        className="bp4-minimal"
                        intent={Intent.NONE}
                        disabled={!terms.diagnosisTerm || !terms.licencesTerm}
                        onClick={handleContinue}
                        text={t("Continue")}
                    />
                </div>
            </div>
        </form>
    )
}
export default DisplayDisclaimerPanel
